import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { ActivityClassificationService } from '../../services/activity-classification.service';

@Component({
  selector: 'app-create-activity-classification',
  templateUrl: './create-activity-classification.component.html',
  styleUrls: ['./create-activity-classification.component.css']
})
export class CreateActivityClassificationComponent implements OnInit {

  activityClassForm: FormGroup;
  classification: any;

  constructor(
    private activityClassificationService: ActivityClassificationService,
    private fb: FormBuilder,
    private router: Router
  ) { }

  ngOnInit() {
    this.activityClassForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      perSection: ['']
    });
  }
  onSubmit() {
    this.classification = this.saveClassification();
    this.activityClassificationService.postActivityClassification(this.classification);
    this.router.navigate(['/activity_class']);
  }
  saveClassification() {
		const currentDate = new Date();

		const classificationJson = {
			active: 1,
			createdAt: currentDate,
			name: this.activityClassForm.get('name').value,
			description: this.activityClassForm.get('description').value,
			perSection: this.activityClassForm.get('perSection').value,
			updatedAt: currentDate
		};

		return classificationJson;
	}

}